var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="modal-dialog '+
((__t=( size ))==null?'':_.escape(__t))+
'">\n  <div class="modal-content">\n    <div class="modal-header">\n      <div>\n        <h4 class="modal-title"></h4>\n        <h5 class="modal-subtitle"></h5>\n      </div>\n      <button type="button" class="close" data-dismiss="modal" aria-label="Close">\n        <span aria-hidden="true">×</span>\n      </button>\n    </div>\n    <div class="modal-body">\n      <div class="modal-body-content">\n      </div>\n      <div class="modal-body-message">\n      </div>\n      <div class="modal-documentation-link">\n      </div>\n    </div>\n    <div class="modal-footer">\n    </div>\n  </div>\n</div>\n';
}
return __p;
};
